import React from 'react';

import { useState, useEffect } from "react";

import { Params, useParams } from 'react-router-dom';

import { Box } from '@mui/material';

import { Videos, ChannelCard } from './';
import { fetchFromAPI } from '../utils/fetchFromAPI';

const ChannelDetail = () => {

  // const [channelDetail, setChannelDeteil] = useState(null);
  // const [videos, setVideos] = useState(null);

  // const {id} = useParams();

  // console.log(channelDetail, videos)

  // useEffect(() => {
  //   fetchFromAPI(`channels?part=snippet&id=${id}`)
  //   .then((data) => setChannelDeteil(data.items[0]));

  //   fetchFromAPI(`search?channelId=${id}&part=snippet&order=date`)
  //   .then((data) => setVideos(data.items));

  // }, [id])

  return (
    <Box></Box>
  )
}

export default ChannelDetail;